import React, { useContext, useEffect, useState } from 'react'
import Success from '../../../../components/Multiple/Success'
import Negotiate from '../../../../components/Multiple/Negotiate'
import DeclinedDelivery from '../../../../components/Multiple/DeclinedDelivery'
import { TiThMenu } from 'react-icons/ti'
import AlertContext from '../../../../Context/Alert/AlertContext'
import { BaseURL } from '../../../../Files/BaseURL'
import { useNavigate, useParams } from 'react-router-dom'
import ThemeContext from '../../../../Context/theme/ThemeContext'
import SocketContext from '../../../../Context/Socket/SocketContext'
import { formatDateandtime, formatDateForInput, getFileNameFromUrl, getfileTypefromurl, OfferStep } from '../../../../Files/UseFunction'
import { FaDownload, FaFileAlt, FaFileImage, FaFileVideo, FaRegFilePdf, FaTimes } from 'react-icons/fa'
import { BsFiletypeDocx } from 'react-icons/bs'
import { MdFolderZip } from 'react-icons/md'
import axios from "axios"
import NegotiateMessage from "../../../../components/Multiple/NegotiateMessage";
import DeliverPopup from "../../../../components/PopUp/DeliverPopup";
import ReviewPopup from "../../../../components/PopUp/ReviewPopup";
import offerDetail from "../CreateOffer/OfferDetail";
import ScrollToBottom from "react-scroll-to-bottom";


const SentChat = () => {
    const [OrderStatus, setOrderStatus] = useState(false)
    const [OfferDetails, setOfferDetails] = useState(null)
    const [Steps, setSteps] = useState([])
    const [message, setmessage] = useState('')
    const [ChatFile, setChatFile] = useState(null)
    const [FileName, setFileName] = useState(null)
    const [UploadedFile, setUploadedFile] = useState(null)
    const [Conversation, setConversation] = useState([])
    const [TotalPages, setTotalPages] = useState(null)
    const [Page, setPage] = useState(null)

    const { sentid } = useParams()
    const navigate = useNavigate()

    const alertcontext = useContext(AlertContext);
    const { showAlert } = alertcontext;
    const { theme } = useContext(ThemeContext);

    const socketcontext = useContext(SocketContext);
    const { OnlineUsers, SocetConnection, isUserOnline } = socketcontext;
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isReviewPopupVisible, setIsReviewPopupVisible] = useState(false);

    const [shouldRevBtnVisble, setShouldRevBtnVisble] = useState(true);


    const reviewed = async () => {
        try {
            const response = await axios.get(`${BaseURL}/api/review/isReviewed/${sentid}`, {
                headers: {
                    'auth-token': localStorage.getItem('p@token')
                }
            })

            if (response.data.isReviewed) {
                setShouldRevBtnVisble(!response.data.isReviewed);
            }
        }
        catch (error) {
            console.error("Review Error:", error);
        }
    }

    useEffect(() => {
        fetchOffer()
    }, [isPopupVisible])

    const fetchconversation = async (id) => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await axios.get(`${BaseURL}/api/offermessage/getMessages/${id}`, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'auth-token': authToken,
                }
            });
            if (response.data.success) {
                setConversation(response.data.messages)
                setTotalPages(response.data.totalPages)
                setPage(response.data.page)
            } else {
                showAlert(response.data.message, 'danger')
            }
        } catch (error) {
            showAlert(error.message, 'danger')
        }
    }

    const updateSeenChat = async (id) => {
        try {
            const authToken = localStorage.getItem('p@token');
            const response = await axios.get(`${BaseURL}/api/offermessage/markAsSeen/${id}`, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'auth-token': authToken,
                }
            });
            if (response.ok) {

            }
        } catch (error) {
            showAlert(error.message, 'danger')
        }
    }

    const fetchOffer = async () => {
        try {
            const authToken = localStorage.getItem("p@token");
            const response = await fetch(`${BaseURL}/api/sentoffers/sentoffer/${sentid}`, {
                method: 'GET',
                headers: {
                    'auth-token': authToken,
                },
            });
            const data = await response.json();
            if (!response.ok) {
                showAlert(`${data.message}`, 'danger');
                return;
            }
            setOfferDetails(data.offer);
            const OfferStepReturn = OfferStep(data.offer.Status)
            setSteps(OfferStepReturn);
        } catch (error) {
            showAlert('Failed to fetch offer details', 'danger');
        }
    }

    useEffect(() => {
        if (sentid) {
            fetchOffer();
            fetchconversation(sentid)
            updateSeenChat(sentid)
            reviewed();
        }
    }, [sentid])


    useEffect(() => {
        if (SocetConnection) {
            const handleMessage = (data) => {
                if (sentid) {
                    fetchconversation(sentid);
                    updateSeenChat(sentid);
                }
            };

            const handleUpdateStatus = () => {
                fetchOffer();
            }

            const handleNegotiation = () => {
                fetchOffer()
            }
            // Attach the event handler
            SocetConnection.on('offermessage', handleMessage);
            SocetConnection.on('updateStatus', handleUpdateStatus);
            SocetConnection.on('Negotiation', handleNegotiation);
            // Cleanup function to remove the event handler
            return () => {
                SocetConnection.off('offermessage', handleMessage);
                SocetConnection.off('updateStatus', handleUpdateStatus);
                SocetConnection.off('Negotiation', handleNegotiation);
            };
        }
    }, [SocetConnection]);

    const handleSendMessage = async (e) => {
        e.preventDefault()
        const userid = OfferDetails?.Buyer?._id

        if (userid) {
            if (message !== "") {
                if (SocetConnection) {
                    SocetConnection.emit('new offer message', {
                        Offer_id: sentid,
                        UserID: userid,
                        covnersation: message,
                        File: {
                            Link: UploadedFile,
                            Name: FileName
                        }
                    })
                    setmessage("")
                    setUploadedFile(null)
                    setFileName(null)
                    setChatFile(null)
                }
            }
        }
    }

    const FileUpload = async (e) => {
        try {
            const file = e.target.files[0];
            setChatFile(file);
            setFileName(file.name);

            const formData = new FormData();
            formData.append('file', file);
            formData.append('filename', file.name);

            const authToken = localStorage.getItem('p@token');
            const response = await fetch(`${BaseURL}/api/offermessage/upload-docs`, {
                method: "POST",
                headers: {
                    'auth-token': authToken,
                },
                body: formData
            });

            if (response.ok) {
                const data = await response.json();
                setUploadedFile(data?.location);
            } else {
                showAlert("File not uploaded, try again", 'danger');
            }
        } catch (error) {
            console.error("File upload error:", error);
            showAlert("File not uploaded, try again", 'danger');
        }
    };

    const renderFileIcon = (file) => {
        const fileType = file;
        switch (fileType) {
            case 'image':
                return <FaFileImage className='text-2xl w-full text-primarygreen' />;
            case 'video':
                return <FaFileVideo className='text-2xl w-full text-primarygreen' />;
            case 'pdf':
                return <FaRegFilePdf className='text-2xl w-full text-red-500' />;
            case 'application':
                return <FaRegFilePdf className='text-2xl w-full text-red-500' />;
            case 'doc':
                return <BsFiletypeDocx className='text-2xl w-full text-blue-500' />;
            case 'docx':
                return <BsFiletypeDocx className='text-2xl w-full text-blue-500' />;
            case 'zip':
                return <MdFolderZip className='text-2xl w-full text-gray-400' />;
            default:
                return <FaFileAlt className='text-2xl w-full text-primarygreen' />;
        }
    };

    // Function to handle the enter key press to send the message
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage(e);
        }
    };

    const cancelOffer = async (offerId) => {
        try {
            const authToken = localStorage.getItem("p@token");
            const response = await axios.delete(`${BaseURL}/api/sentoffers/canceloffer/${offerId}`, {
                headers: {
                    'auth-token': authToken,
                }
            });

            // Checking if the request was successful
            if (response.data.success) {
                showAlert(response.data.message, 'success');
                navigate("/user-dashboard/offers/send")
            } else {
                showAlert(response.data.message, 'danger');
            }
        } catch (error) {
            showAlert('Failed to cancel the offer', 'danger');
            console.error("Cancel Offer Error:", error);
        }
    }

    return (

        <div className='min-h-full overflow-hidden'>
            {
                isPopupVisible && <DeliverPopup setIsPopupVisible={setIsPopupVisible} />
            }
            {
                isReviewPopupVisible && <ReviewPopup setIsReviewPopupVisible={setIsReviewPopupVisible} userId={OfferDetails.Buyer._id} offerId={OfferDetails._id} reviewBtn={setShouldRevBtnVisble} />
            }
            <div className="bg-white font-pop w-full px-2 md:px-6">
                <div className="flex flex-row md:flex-row justify-between md:items-center">
                    <div className="flex flex-row gap-4 items-center">
                        {OfferDetails?.Buyer?.ProfilePhoto ? (
                            <div className='relative rounded-full w-8 md:w-12 h-8 md:h-12'>
                                <img src={OfferDetails?.Buyer?.ProfilePhoto} alt="" className='w-full h-full object-cover rounded-full' />
                                {isUserOnline(OfferDetails?.Buyer?._id) && <div
                                    className='bg-primarygreen rounded-full h-3 w-3 absolute bottom-1 -right-1'>
                                </div>}
                            </div>

                        ) : (
                            <div className={`w-8 md:w-12 h-8 md:h-12 rounded-full font-pop  flex items-center justify-center ${theme == "dark" ? "bg-black text-white" : "bg-gray-400 "}`}>
                                <span className='text-white'>{OfferDetails?.Buyer?.FirstName && OfferDetails?.Buyer?.FirstName?.charAt(0)}</span>
                            </div>
                        )}
                        <div className="flex flex-col">
                            <h2 className='text-sm md:text-lg font-semibold'>{OfferDetails?.Buyer?.FirstName} {OfferDetails?.Buyer?.LastName}</h2>
                            <p className='text-xs md:text-base text-gray-400'>{isUserOnline(OfferDetails?.Buyer?._id) ? <span className='text-primarygreen'>Online</span> : "Offline"}</p>
                        </div>
                    </div>
                    <div className="flex flex-row gap-2 items-center">
                        {OfferDetails?.Status === "New" ?
                            <button
                                className="my-4 w-fit px-2 md:px-6 bg-transparent hover:bg-primarygreen text-black hover:text-white font-semibold font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full "
                                onClick={() => { cancelOffer(sentid) }}
                            >
                                Cancel Offer
                            </button>
                            :
                            (OfferDetails?.Status === "In progress" && (
                                <button
                                    className="my-4 w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white"
                                    onClick={() => { setIsPopupVisible(true) }}
                                >
                                    Deliver now
                                </button>)
                            )
                        }
                        {
                            OfferDetails?.Status === "Completed" && shouldRevBtnVisble && (
                                <button
                                    className="my-4 w-fit px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-semibold hover:text-black font-pop text-sm md:text-base py-1 md:py-2 border border-black-500 hover:border-green-500 rounded-full  text-white"
                                    onClick={() => setIsReviewPopupVisible(true)}
                                >
                                    Give Review
                                </button>
                            )
                        }
                        <TiThMenu className="text-xl block lg:hidden" onClick={() => {
                            setOrderStatus(true)
                        }} />
                    </div>

                </div>
            </div>
            <div className="flex flex-row min-h-full basis-[100%] h-max">
                <div className="lg:basis-[70%] font-pop px-4 py-4">
                    <div className="flex flex-col gap-6 h-[100%] justify-between">
                        <ScrollToBottom className="flex flex-col gap-2">
                            <div className="h-[calc(100vh-300px)]">
                                <div className="flex flex-col gap-2 px-2">
                                    {Conversation?.length > 0 && Conversation?.map((item, index) => (
                                        <div className={`${item.tag === "Sender" ? "flex flex-col justify-end" : " flex flex-col justify-start"} my-1 gap-1`}>
                                            {item?.File?.Link &&
                                                <div className={` p-2 rounded w-fit shadow-md font-pop flex items-end ${item.tag === "Sender" ? "bg-primarygreen/50 self-end text-white" : "bg-gray-300"}`}>
                                                    <div className="flex flex-col gap-2">
                                                        {item?.File && renderFileIcon(item?.File?.Link)}
                                                        <span className="ml-2">{item?.File?.Name}</span>
                                                    </div>
                                                    <a href={item?.File?.Link} download={true} target='_blank'>
                                                        <FaDownload
                                                            className="ml-2 text-3xl text-gray-500 cursor-pointer"
                                                        />
                                                    </a>
                                                </div>
                                            }
                                            {item?.CreatedBY === 'SystemNegotiationAccept'
                                                ? <Negotiate Seller={true} /> :
                                                item?.CreatedBY === 'SystemNegotiation'
                                                    ? <NegotiateMessage Seller={true} Message={item?.message} /> :
                                                    item?.CreatedBY === 'SystemDeclineDelivery' ?
                                                        <DeclinedDelivery item={item?.message} offer={sentid} /> :
                                                        item?.CreatedBY === 'System'
                                                            ? <Success /> :
                                                            <div
                                                                className={`${item.tag === "Sender" ? "bg-primarygreen self-end text-white" : "bg-[#E8E8E8]"} rounded-xl py-2 px-3 max-w-xs w-fit`}>
                                                                <p className='text-sm md:text-base'>{item?.message}</p>
                                                            </div>
                                            }
                                            {item.CreatedBY !== 'System' && item.CreatedBY !== 'SystemNegotiation' && item?.CreatedBY !== 'SystemNegotiationAccept' && item?.CreatedBY !== 'SystemDeclineDelivery' &&
                                                <p className={`${item.tag === "Sender" ? "text-right" : "text-left"} text-xs`}>
                                                    {formatDateForInput(item?.date)}
                                                </p>
                                            }
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </ScrollToBottom>
                        <div className="flex flex-row font-pop justify-between items-center bg-[#E8E8E8] rounded-2xl py-1 md:py-2 px-2 md:px-4">
                            <div className="flex w-[100%] flex-row items-center gap-2">
                                <label htmlFor="fileupload" className='relative'>
                                    <img
                                        src="../../../../Assets/Prop/docattach.png"
                                        alt=""
                                        className='w-8 h-8'
                                    />
                                    <input
                                        type="file"
                                        id='fileupload'
                                        onChange={FileUpload}
                                        className='opacity-0 absolute'
                                    />
                                </label>
                                <div className="flex gap-2 w-full">
                                    {UploadedFile !== "" && UploadedFile !== null
                                        &&
                                        <div className="bg-gray-300 p-2 rounded shadow-md font-pop flex items-center">
                                            <div className="flex flex-col gap-2">
                                                {ChatFile && renderFileIcon(ChatFile)}
                                                <span className="ml-2 w-max text-xs">{FileName}</span>
                                            </div>
                                            <FaTimes
                                                className="ml-2 text-red-500 cursor-pointer"
                                                onClick={() => {
                                                    setChatFile(null);
                                                    setFileName(null);
                                                    setUploadedFile(null);
                                                }}
                                            />
                                        </div>
                                    }
                                    <input
                                        type="text"
                                        value={message}
                                        onChange={(e) => { setmessage(e.target.value) }}
                                        onKeyDown={handleKeyDown}
                                        placeholder='Message...'
                                        className='text-lg w-[100%] font-normal border-transparent outline-none focus:outline-none focus:border-transparent active:border-transparent active:outline-none bg-transparent'
                                    />
                                </div>
                            </div>
                            <img
                                src="../../../../Assets/Prop/messagesend.png"
                                alt=""
                                onClick={handleSendMessage}
                                className='w-4 h-4 md:w-8 md:h-8 cursor-pointer'
                            />
                        </div>
                    </div>
                </div>
                <div className={`lg:basis-[30%] left-0 top-0 w-[100vw] h-[100vh] lg:w-[100%] lg:h-[calc(100vh-160px)] fixed lg:relative z-50 ${OrderStatus == true ? "block" : "hidden lg:block"} font-pop `}>
                    <div className="absolute bg-black/50 block lg:hidden w-[100vw] h-[100vh] z-30" onClick={() => { setOrderStatus(false) }}></div>
                    <div className='py-4 px-6 bg-white max-w-[90%] lg:max-w-full max-h-[70vh] lg:max-h-full mt-16 lg:mt-0 overflow-y-auto h-fit lg:h-full rounded-xl lg:rounded-none relative z-40 flex flex-col gap-4 justify-center lg:justify-start items-center m-auto'>
                        <div className="border-2 border-[#E9E9E9] w-full rounded-2xl py-4 px-4">
                            <div className="flex justify-between">
                                <div className="flex flex-col gap-2">
                                    <div className={`
                                        py-2 px-4 rounded-lg border-2 w-fit font-medium 
                                        ${OfferDetails?.Status === "New"
                                            ? "bg-[#8A39F2]/30 border-[#8A39F2] text-[#8A39F2]"
                                            : OfferDetails?.Status === "In progress"
                                                ? "bg-[#EBF4FE] border-[#3992F2] text-[#3992F2]"
                                                : OfferDetails?.Status === "Delivered"
                                                    ? "bg-[#FCEBFE] border-[#E339F2] text-[#E339F2]"
                                                    : OfferDetails?.Status === "Completed"
                                                        ? "bg-[#EFFBF1] border-[#63D577] text-[#63D577]"
                                                        : OfferDetails?.Status === "Under review"
                                                            ? "bg-[#FEF8EE] border-[#F9B754] text-[#F9B754]"
                                                            : "bg-[#FCEBEC] border-[#DD3242] text-[#DD3242]"
                                        }`}>
                                        {OfferDetails?.Status}
                                    </div>
                                    <h2 className='text-lg font-semibold'>{OfferDetails?.Type}</h2>
                                </div>
                                <div className="flex flex-col gap-2">
                                    <p className='text-sm text-gray-400'>{formatDateandtime(OfferDetails?.date)}</p>
                                    <p className='font-medium text-primarygreen'>${OfferDetails?.Price}</p>
                                </div>
                            </div>
                            <p className='font-medium'>{OfferDetails?.Type}</p>
                        </div>
                        <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
                            <p className='text-lg text-gray-400'>Buyer</p>
                            <div className="flex flex-row gap-2 items-center">
                                {OfferDetails?.Buyer?.ProfilePhoto ? (
                                    <div className='relative rounded-full w-8 md:w-12 h-8 md:h-12'>
                                        <img src={OfferDetails?.Buyer?.ProfilePhoto} alt="" className='w-full h-full object-cover rounded-full' />
                                        {isUserOnline(OfferDetails?.Buyer?._id) && <div
                                            className='bg-primarygreen rounded-full h-3 w-3 absolute bottom-1 -right-1'>
                                        </div>}
                                    </div>

                                ) : (
                                    <div className={`w-8 md:w-12 h-8 md:h-12 rounded-full font-pop  flex items-center justify-center ${theme == "dark" ? "bg-black text-white" : "bg-gray-400 "}`}>
                                        <span className='text-white'>{OfferDetails?.Buyer?.FirstName && OfferDetails?.Buyer?.FirstName?.charAt(0)}</span>
                                    </div>
                                )}
                                <h2 className='font-semibold'>{OfferDetails?.Buyer?.FirstName} {OfferDetails?.Buyer?.LastName}</h2>
                            </div>
                        </div>
                        <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
                            <p className='text-lg text-gray-400'>Attached files</p>
                            <div className="flex flex-col gap-2">
                                {OfferDetails?.FileAttached?.map((item, index) => (
                                    <a href={item.src} target='_blank' download={true} className="flex flex-row gap-2 items-center" key={index}>
                                        <img src={getfileTypefromurl(item.src) == "pdf" ? "../../../Assets/Prop/pdf.png" : "../../../Assets/Prop/IDIcon.png"} alt="" className='w-8 h-8' />
                                        <h2 className='font-semibold'>{getFileNameFromUrl(item.src)}</h2>
                                    </a>
                                ))}
                            </div>
                        </div>
                        <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
                            <p className='text-lg text-gray-400'>Offer timeline</p>
                            <div className="flex flex-col gap-1">
                                {Steps?.map((step, i) => (
                                    <div className="flex flex-row items-center justify-between" key={i}>
                                        <div className="flex flex-row gap-2 items-center">
                                            <img src="../../../Assets/Prop/tick.png" alt="" className='w-6 h-6' />
                                            <h2 className='font-semibold'>{step.stage}</h2>
                                        </div>
                                        <p className='text-lg text-gray-400'>04 Dec</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SentChat